import React from 'react';

const Icon = ({ size = '40', fill = 'url(#prefix_dxc-svg-to-react_a)', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 40 40" fill="none" {...other}>
            <path
                d="M37.125 12.525v-1.667l-1.26-.581L20.125 3 4.368 10.49l-1.243.592v18.753l15.725 6.624 1.275.541 1.275-.551 15.725-6.839V12.525Zm-17-6.696 12.586 5.815-1.912.827-2.905 1.265-12.112-5.844 4.343-2.063ZM18.85 33.681 5.675 28.125V13.807l13.175 5.556v14.318Zm1.275-16.562-8.203-3.447-4.39-1.848 5.294-2.52L24.81 15.09l-4.686 2.03Zm14.45 10.81L21.4 33.657V19.363l13.175-5.73v14.295Z"
                fill="url(#a)"
            />

            <defs>
                <linearGradient id="a" x1="34.175" y1="44.72" x2="-3.096" y2="43.904" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FE6E00" />

                    <stop offset="1" stopColor="#F7A202" />
                </linearGradient>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
